<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="Job"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
    <JobHeader
      :item="resource"
      @reload="evh_8564662037462133_reload($event, {})"
      @deleted="evh_8564662037462133_deleted($event, {})"
    >
    </JobHeader>
  </UcHeader>
  <DIV
    class="px-4 py-3 h-100 overflow-hidden"
    :style="b_5962862420439144_style"
  >
    <JobView
      :item="resource"
      v-if="resource"
      @reload="evh_1040167445267876_reload($event, {})"
    >
    </JobView>
  </DIV>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      @click.prevent.stop="evh_1548630417156826_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class Job extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: String,
  })
  oid!: string;

  @Watch('oid')
  onOid(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("oid")
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  resource!: any;

  async $$load_resource() {
    return this.$fn.fetch('read_a_job', { parameters: { id: this.oid }, asResource: true })
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_5962862420439144_style!: any;
  dataMembers = ['resource', 'ux', 'b_7315092382398562_modalBindings', 'b_5962862420439144_style'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        resource: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "lg",
        }
        ,
        b_5962862420439144_style: {
          minHeight: "200px",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: [this.$fn.pgettext("Job|Title", "Job")
          ,
        this.resource.name
          ,
        this.resource.id
          ,
        ]
        ,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_7710_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_7710, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async evh_8564662037462133_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8564662037462133_reload.executeFromDOM(this, event, scope);
  }

  async act_8564662037462133_reloadSlickgrid_7718_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_8564662037462133_reloadSlickgrid_7718, alias=undefined
    return {
      grid: "jobs",
    }
  }

  async evh_8564662037462133_deleted(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8564662037462133_deleted.executeFromDOM(this, event, scope);
  }

  async evh_1040167445267876_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_reload.executeFromDOM(this, event, scope);
  }

  async evh_1548630417156826_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_7710: actions.CloseModalAction;
    evh_7315092382398562_close_7709: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_7712: actions.CloseComponentAction;
    evh_2248226175642056_close_7711: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_8564662037462133_reloadComponentData_7714: actions.ReloadComponentDataAction;
    evh_8564662037462133_reload_7713: actions.EventHandlerImpl;
    evh_8564662037462133_reload: actions.EventHandlerGroup;
    act_8564662037462133_closeModal_7716: actions.CloseModalAction;
    evh_8564662037462133_deleted_7715: actions.EventHandlerImpl;
    act_8564662037462133_reloadSlickgrid_7718: actions.ReloadSlickgridAction;
    evh_8564662037462133_deleted_7717: actions.EventHandlerImpl;
    evh_8564662037462133_deleted: actions.EventHandlerGroup;
    act_1040167445267876_reloadComponentData_7720: actions.ReloadComponentDataAction;
    evh_1040167445267876_reload_7719: actions.EventHandlerImpl;
    evh_1040167445267876_reload: actions.EventHandlerGroup;
    act_1548630417156826_closeComponent_7722: actions.CloseComponentAction;
    evh_1548630417156826_clickPreventStop_7721: actions.EventHandlerImpl;
    evh_1548630417156826_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_7710 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_7710_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_7709 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_7710,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_7709],
      }
    );
    const act_2248226175642056_closeComponent_7712 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_7711 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_7712,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_7711],
      }
    );
    const act_8564662037462133_reloadComponentData_7714 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_8564662037462133_reload_7713 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_reloadComponentData_7714,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_8564662037462133_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_8564662037462133_reload_7713],
      }
    );
    const act_8564662037462133_closeModal_7716 = new actions.CloseModalAction(
      {
        events: [],
      }
    );
    const evh_8564662037462133_deleted_7715 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_closeModal_7716,
        event: "deleted",
        displayName: "closeModal",
      }
    );
    const act_8564662037462133_reloadSlickgrid_7718 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_8564662037462133_reloadSlickgrid_7718_getActionArgs,
        events: [],
      }
    );
    const evh_8564662037462133_deleted_7717 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_reloadSlickgrid_7718,
        event: "deleted",
        displayName: "reloadSlickgrid",
      }
    );
    const evh_8564662037462133_deleted = new actions.EventHandlerGroup(
      {
        handlers: [evh_8564662037462133_deleted_7715, evh_8564662037462133_deleted_7717],
      }
    );
    const act_1040167445267876_reloadComponentData_7720 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_1040167445267876_reload_7719 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_reloadComponentData_7720,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_1040167445267876_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_reload_7719],
      }
    );
    const act_1548630417156826_closeComponent_7722 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_1548630417156826_clickPreventStop_7721 = new actions.EventHandlerImpl(
      {
        action: act_1548630417156826_closeComponent_7722,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_1548630417156826_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1548630417156826_clickPreventStop_7721],
      }
    );
    return {
      act_7315092382398562_closeModal_7710,
      evh_7315092382398562_close_7709,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_7712,
      evh_2248226175642056_close_7711,
      evh_2248226175642056_close,
      act_8564662037462133_reloadComponentData_7714,
      evh_8564662037462133_reload_7713,
      evh_8564662037462133_reload,
      act_8564662037462133_closeModal_7716,
      evh_8564662037462133_deleted_7715,
      act_8564662037462133_reloadSlickgrid_7718,
      evh_8564662037462133_deleted_7717,
      evh_8564662037462133_deleted,
      act_1040167445267876_reloadComponentData_7720,
      evh_1040167445267876_reload_7719,
      evh_1040167445267876_reload,
      act_1548630417156826_closeComponent_7722,
      evh_1548630417156826_clickPreventStop_7721,
      evh_1548630417156826_clickPreventStop,
    }
  }
}

Vue.component("Job", Job);

</script>